<template>
  <div class="details-component">
    <div class="details-component__header" v-on:click="toggleSection">
      <h1 class="header">{{ $t('end_user.profile') }}</h1>
      <div class="details-component__header_right">
        <div :class="!showSection ? toggleIconDown : toggleIconUp"/>
      </div>
    </div>
    <div class="profile-wrapper" v-show="showSection">
      <div class="row">
        <div class="profile-details-wrapper">

          <div class="profile-field">
            <div class="profile-field-description">{{ $t('common.user') }}</div>
            <div  class="profile-details">
              <el-input
                id="name"
                name="name"
                class="nameInput-toggle"
                :placeholder="$t('common.name')"
                v-model="form.name"
                v-validate="'required|max:255'"
                :data-vv-as="$t('common.name')"
                data-vv-delay="1000"
                ref="nameInput"
                disabled
              >
              </el-input>
              <tooltip v-show="errors.has('name')" class="form__validation">{{ $t('errors.name_field') }}</tooltip>
            </div>
          </div>

          <div class="profile-field">
            <div class="profile-field-description">{{ $t('common.phone') }}</div>
            <div class="profile-details">
              <el-input
                id="mobile"
                name="mobile"
                class="phoneInput-toggle"
                :placeholder="$t('common.phone')"
                v-model.trim="mobileNumber"
                :data-vv-as="$t('common.phone')"
                data-vv-delay="1000"
                ref="passwordInput"
                @keyup.enter.native="toggleInput('phoneInput')"
              >
                <el-button
                  :class="{ 'phoneInput-toggle': phoneInputDisabled, 'on-click-trigger-submit': !phoneInputDisabled }"
                  slot="append" :icon="phoneInputDisabled ? 'el-icon-edit' : ''"
                  >
                    {{ phoneInputDisabled ? '' : $t('common.ok') }}
                </el-button>
              </el-input>
              <tooltip v-show="errors.has('mobile')" class="form__validation">{{ $t('errors.phone_field') }}</tooltip>
            </div>
          </div>

          <div class="profile-field">
            <div class="profile-field-description">{{ $t('common.password') }}</div>
            <div class="profile-details">
              <el-input
                  id="not_the_password"
                  type="password"
                  name="not_the_password"
                  class="notPassword-toggle"
                  :placeholder="$t('common.your_new_password')"
                  v-model.trim="password"
                  :data-vv-as="$t('common.your_new_password')"
                  data-vv-delay="1000"
                  ref="notPassword"
                  autocomplete="off"
                  auto-complete="off"
                  autocorrect="off"
                  autocapitalize="none"
                  spellcheck="false"
              >
              </el-input>
              <el-input
                  id="not_repeat_password"
                  type="password"
                  name="not_repeat_password"
                  class="notRepeatPassword-toggle"
                  :placeholder="$t('common.repeat_new_password')"
                  v-model.trim="repeatPassword"
                  :data-vv-as="$t('common.repeat_new_password')"
                  data-vv-delay="1000"
                  ref="notRepeatPassword"
                  autocomplete="off"
                  auto-complete="off"
                  autocorrect="off"
                  autocapitalize="none"
                  spellcheck="false"
              >
                <el-button slot="append" icon="el-icon-check" v-on:click.prevent.stop="onChangePassword()"></el-button>
              </el-input>
            </div>
          </div>

        </div>
      </div>
    </div>

    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ warningHeader }}</h1>
      <p slot="body">{{ warningBody }}</p>
    </WarningModal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { parse, format, isValidNumber } from 'libphonenumber-js';
import * as mTypes from 'store/mutation-types';
import Tooltip from 'common/Tooltip';
import WarningModal from 'common/WarningModal';

export default {
  components: {
    Tooltip,
    WarningModal,
  },
  data() {
    return {
      form: {},
      warningHeader: null,
      warningBody: null,
      showWarningModal: false,
      nameInputDisabled: true,
      phoneInputDisabled: true,
      mobileNumber: null,
      password: null,
      repeatPassword: null,
      showSection: false,
      toggleIconDown: 'icon icon-bl-arrow-down',
      toggleIconUp: 'icon icon-bl-arrow-up'
    };
  },
  computed: Object.assign(mapGetters({
    user: 'user/user/user',
    selectedUser: 'users/user/user',
    userError: 'users/user/error',
  }), {
    username() {
      return this.form.name;
    },
  }),
  mounted() {
    this.fetchUser();
  },
  created() {
    this.$store.commit(`users/user/${mTypes.CLEAR_STATE}`);
    this.resetValidators();
    this.createValidators();
    document.removeEventListener('click', window.eventListenerForEditViewProfile);
    window.eventListenerForEditViewProfile = this.handleInput;
    document.addEventListener('click', this.handleInput, false);
  },
  methods: {
    toggleInput(buttonRef) {
      this.callSubmitIfInputIsEnabled(buttonRef);
      this[`${buttonRef}Disabled`] = !this[`${buttonRef}Disabled`];
      this.blurInput(buttonRef);
    },
    callSubmitIfInputIsEnabled(buttonRef) {
      if (!this[`${buttonRef}Disabled`]) {
        this.onSubmit();
      }
    },
    handleInput(event) {
      if (event.target && (event.target.classList.contains('on-click-trigger-submit') || event.target.parentElement.classList.contains('on-click-trigger-submit'))) {
        this.onSubmit();
      }
      let buttonRef = false;
      this.nameInputDisabled = true;
      this.phoneInputDisabled = true;
      if (event.target && (event.target.classList.contains('nameInput-toggle') || event.target.parentElement.classList.contains('nameInput-toggle'))) {
        buttonRef = 'nameInput';
      } else if (event.target && (event.target.classList.contains('phoneInput-toggle') || event.target.parentElement.classList.contains('phoneInput-toggle'))) {
        buttonRef = 'phoneInput';
      }
      if (buttonRef) {
        this[`${buttonRef}Disabled`] = false;
        this.focusInput(buttonRef);
      }
    },
    focusInput(buttonRef) {
      if (!this[`${buttonRef}Disabled`]) {
        this.$nextTick(() => this.$refs[buttonRef].$refs.input.focus());
      }
    },
    blurInput(buttonRef) {
      this.$nextTick(() => this.$refs[buttonRef].$refs.input.blur());
    },
    fetchUser() {
      this.$store.dispatch('users/user/fetch', { id: this.user.data.selectedRole.id, user: this.user }).then(() => {
        this.form = this.selectedUser;
        this.formatMobileNrForForm();
        this.mobileNumber = this.form.mobile;
        const newUser = JSON.parse(localStorage.getItem('user'));
        for (let index = 0; index < newUser.roles.length; index += 1) {
          if (newUser.roles[index].id === this.selectedUser.id) {
            newUser.roles[index].name = this.selectedUser.name;
            newUser.selectedRole = newUser.roles[index];
          }
        }
        localStorage.setItem('user', JSON.stringify(newUser));
        this.$store.commit(`user/user/${mTypes.LOG_IN}`);
      });
    },
    formatMobileNrForForm() {
      if (this.form.mobile) {
        this.form.mobile = format({ country: this.form.mobileCountry, phone: this.form.mobile.toString() }, 'International_plaintext');
      } else {
        this.form.mobile = '';
      }
    },
    onChangePassword() {
      if (!this.password || this.password.length < 6) {
        this.warningHeader = this.$t('common.warning');
        this.warningBody = this.$t('login.password_error');
        this.showWarningModal = true;
        return;
      } else if (this.repeatPassword !== this.password) {
        this.warningHeader = this.$t('common.warning');
        this.warningBody = this.$t('common.passwords_dont_match');
        this.showWarningModal = true;
        return;
      }
      this.$store.dispatch('users/user/setPassword',
        { userId: this.selectedUser.id,
          data: { password: this.password },
          user: this.user }).then(() => {
        if (this.userError) {
          this.warningHeader = this.$t('accounts.set_password_error_header');
          this.warningBody = this.$t('accounts.set_password_error');
          this.showWarningModal = true;
        } else {
          this.warningHeader = this.$t('login.new_password_set');
          this.warningBody = this.$t('login.password_changed');
          this.showWarningModal = true;
        }
      }).catch(() => {
        this.warningHeader = this.$t('accounts.set_password_error_header');
        this.warningBody = this.$t('accounts.set_password_error');
        this.showWarningModal = true;
      });
    },
    onSubmit() {
      this.$validator.validateAll(
        { name: this.form.name,
          mobile: this.form.mobile,
        })
        .then((success) => {
          this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, null);
          if (success) {
            this.parsePhoneBeforeSave();
            this.$store.dispatch('users/user/saveUser', { selectedUser: this.form, user: this.user })
              .then(() => {
                if (this.userError) {
                  this.warningHeader = this.$t('common.warning');
                  this.warningBody = this.$t('users.save_error_email');
                  this.showWarningModal = true;
                } else {
                  this.fetchUser();
                }
              })
              .catch(() => {
                this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, true);
              });
          } else {
            this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, true);
          }
        })
        .catch(() => {
          this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, true);
        });
    },
    parsePhoneBeforeSave() {
      const parsedPhone = parse(this.mobileNumber, { country: { default: 'EE' } });
      this.form.mobileCountry = parsedPhone.country;
      this.form.mobile = parsedPhone.phone;
    },
    resetValidators() {
      this.$validator.remove('validMobile');
      this.$validator.clean();
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    createValidators() {
      this.createPhoneNrValidator();
    },
    createPhoneNrValidator() {
      this.$validator.extend('validMobile', {
        getMessage: () => 'Please insert valid phone number. Mobile number must include country code.',
        validate: (value) => {
          if (value.trim === '') {
            return true;
          }
          const parsed = parse(value, { country: { default: 'EE' } });
          return isValidNumber(parsed);
        },
      });
    },
    toggleSection() {
      this.showSection = !this.showSection
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/app.scss';

.icon {
  width: 28px !important;
  height: 28px !important;
}

h1 {
  font-size: larger;
}

.profile-wrapper {
  width: 100%;
  background-color: var(--white);

  .row {
    @include enduser-row;
    padding-right: 20px;

    @media screen and (max-width: 1000px) {
      padding-right: 20px;
    }

    .header {
      @include enduser-header;
    }

    .profile-details-wrapper {
      width: 100%;
      display: inline-block;

      @media screen and (max-width: 1000px) {
        width: 100%;
      }

      .profile-field {
        margin: 0;
        padding: 12.5px 0;
        border-bottom: solid 1.5px var(--grey-four);
        display: flex;
        font-size: 16px;

        .profile-field-description {
          line-height: 40px;
          color: var(grey-nine);
          width: 20%;
          text-align: left;
          display: inline-block;
          margin: 0 25px;
          font-size: 14px;

          @media screen and (max-width: 520px) {
            display: none;
          }

        }

        .profile-details {
          color: var(--black);
          font-weight: 900;
          width: 45%;
          text-align: left;
          display: inline-block;
          padding: 0 0 0 35px;
          flex: 1;
          position: relative;

          @media screen and (max-width: 520px) {
            width: 100%;
            padding: 0;
            text-align: center;
          }

        }

        .el-button {
          width: 54px;
        }

        .el-input {
          max-width: 285px;

        }

      }

    }

  }

}


.profile-wrapper {

  .row {

    .profile-details-wrapper {

      .profile-field {

        .profile-details .el-button {
          padding: 0;

          span {
            margin: 0;
          }

        }

        .tooltip {
          top: 5px;
          right: auto;
          left: 100px;
          z-index: 2000;
          max-height: none;

          &__content {

            @media screen and (max-width: 1000px) {
              max-height: none;
              height: auto;
              white-space: pre-wrap;
              max-width: 150px;

            }

          }

        }

      }

    }

  }

}

</style>



// WEBPACK FOOTER //
// src/components/end-user/EditViewProfile.vue